<template>
  <section class="dialog-wrap" v-if="show">
    <div class="dialog-overlay"></div>
    <div class="dialog-outer">
      <div class="dialog">
        <div class="dialog-bd">
          <div class="dialog-tit" v-if="title">{{title}}</div>
          <div class="dialog-cnt" :class="[center ? '' : 'dialog-cnt_left']" v-html="msg" v-if="msg"></div>
        </div>
        <div class="dialog-ft">
          <button type="button" class="dialog-btn dialog-btn_default" @click="cancel()">{{cancelText}}</button>
          <button type="button" class="dialog-btn dialog-btn_primary" @click="success()">{{submitText}}</button>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import pageChange from '../mixins'
  export default {
    name: "confirm",
    mixins: [pageChange],
    props: {
      title: {
        type: String,
        default: ''
      },
      msg: {
        type: String,
        default: ''
      },
      center:{
        type:Boolean,
        default:true
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      submitText: {
        type: String,
        default: '确定'
      },
    },
    data() {
      return {
        show:true
      }
    },
    methods: {
      success(){
        this.show=false;
      },
      cancel(){
        this.show=false;
      }
    }
  }
</script>

<style scoped>
  .dialog-wrap {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .dialog-overlay {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 4001;
  }
  .dialog-outer{
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
    z-index: 4005;
    transform: translate(0,-50%);
  }
  .dialog {
    width: 280px;
    margin: auto;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    -webkit-animation: b .3s 0ms ease both;
    animation: b .3s 0ms ease both;
  }
  @keyframes b {
    0% {
      opacity: 0;
      -webkit-transform: scale(.5);
    }
    100% {
      opacity: 1;
      -webkit-transform: scale(1);
    }
  }
  .dialog .dialog-bd {
    position: relative;
    padding: 15px;
  }
  .dialog .dialog-tit{
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
  }
  .dialog .dialog-cnt{
    font-size: 14px;
    color: #666;
    max-height: 320px;
    overflow-y: auto;
    text-align: center;
  }
  .dialog .dialog-cnt.dialog-cnt_left{
    text-align: left;
  }

  .dialog .dialog-ft {
    overflow: hidden;
    text-align: center;
    line-height: 44px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .dialog .dialog-ft .dialog-btn {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 1%;
    font-size: 14px;
  }

  .dialog .dialog-ft button {
    line-height: normal;
    height: 44px;
    border: none;
    background: transparent;
    border: none;
    outline: none;
  }

  .dialog .dialog-ft .dialog-btn {
    position: relative;
  }
  .dialog-btn_default{
    color: #353535;
    font-weight: 400;
  }
  .dialog-btn_primary{
    color: #09BB07;
    font-weight: 600;
  }

  .dialog .dialog-ft .dialog-btn::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    right: 0;
    height: 0;
    -webkit-transform: scaleY(0.5);
    -ms-transform: scaleY(0.5);
    transform: scaleY(0.5);
    border-top: 1px solid #dbdbdb;
  }

  .dialog .dialog-ft .dialog-btn:nth-of-type(1)::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 0;
    bottom: 0;
    -webkit-transform: scaleX(0.5);
    -ms-transform: scaleX(0.5);
    transform: scaleX(0.5);
    border-left: 1px solid #dbdbdb;
    left: auto;
    right: 0;
  }

  .dialog .dialog-ft .dialog-btn:first-of-type {
    border-bottom-left-radius: 5px;
  }

  .dialog .dialog-ft .dialog-btn:last-of-type {
    border-bottom-right-radius: 5px;
  }

  .dialog .dialog-ft .dialog-btn:hover, .dialog .dialog-ft .dialog-btn:active {
    background: #f5f5f5;
  }

  .dialog .dialog-ft.dialog-ft_full {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn {
    width: 100%;
    border-left: none;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn:first-of-type::after {
    display: none;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn:first-of-type {
    border-bottom-left-radius: 0;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn:last-of-type {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/confirm/confirm.vue